<template>
    <!-- 灵活账户体系  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[8, 3]" :rbgStyle="{
            maxWidth: '80%'
        }" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'account',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0-_BG-3.png",
            rightBg: "/img/pay/0--41.png",
        }
    },
    computed: {
        title() {
            return this.$t('account.title');
        },
        subtitle() {
            return this.$t('account.subtitle');
        },
        description() {
            return [this.$t('account.description1')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>